/* global axios */

import ApiClient from './ApiClient';

class IntegrationsAPI extends ApiClient {
  constructor() {
    super('integrations/apps', { accountScoped: true });
  }

  connectSlack(code) {
    return axios.post(`${this.baseUrl()}/integrations/slack`, {
      code: code,
    });
  }

  delete(integrationId) {
    return axios.delete(`${this.baseUrl()}/integrations/${integrationId}`);
  }

  createHook(hookData) {
    if (hookData?.account_id) {
      return axios.post(`${this.baseUrl()}/integrations/hooks`, hookData, {
        headers: {
          'account-id': hookData?.account_id,
        },
      });
    }
    return axios.post(`${this.baseUrl()}/integrations/hooks`, hookData);
  }

  updateHook({ hookId, hookData }) {
    return axios.patch(
      `${this.baseUrl()}/integrations/hooks/${hookId}`,
      hookData
    );
  }

  deleteHook(hookId) {
    return axios.delete(`${this.baseUrl()}/integrations/hooks/${hookId}`);
  }

  // get boost
  fetchBoostUrl() {
    return axios.get(`${this.baseUrl()}/integrations/boost`);
  }

}

export default new IntegrationsAPI();
